module.exports = __webpack_public_path__ + "19a6030cea913a5c6072aff81332d695.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/otag.svg
// module id = 770
// module chunks = 0